import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: (lng) =>
        `${process.env.REACT_APP_BASE_URL}/translations?lng=${lng}`,
      request: (options, url, payload, callback) => {
        fetch(url)
          .then((res) => res.json())
          .then((data) => {
            callback(null, { status: 200, data: data });
          });
      },
    },
    fallbackLng: "en",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
